const IdeationContent = {
	meta: "Ideation",
	title: "Exploring a quantity of solutions",
	paras: [
		"The team had a wealth of quant + qual data from which to start unleashing creative ideas. Using a structured workshop session, the team clarified problem statements before tackling each by sketching solutions.",
		"We worked together, but alone, minimizing open discussion and allowing for each team member to come at the problem statement from their perspective. The team included product, engineering, design, and marketing.",
		"Once a multitude of sketched solutions were posted up, we voted on what was most desirable, feasible, viable to get done quickly and ready for testing.",
	],
	img01alt: "Whiteboard with stickies",
	img01caption: "Team observations from lab testing cruise customers",
	img02alt: "Hotjar heat map",
	img02caption: "Utilising user behavior software like Hotjar",
};

export default IdeationContent;
